export var MockFrContentTypeName; // empty

(function (MockFrContentTypeName) {
  MockFrContentTypeName["Slideshow"] = "MOCK_FR_SLIDESHOW";
  MockFrContentTypeName["FieldTypes"] = "MOCK_FR_FIELD_TYPES";
})(MockFrContentTypeName || (MockFrContentTypeName = {}));